import type {ControlOption} from 'shells/card/segmented-control';
import {colors} from 'shells/colors/colors';

import type {ComparisonEditionType, ComparisonMetricType} from 'nutshell-graphql-types';
import type {EditionFragment as Edition} from 'nutshell-graphql-types';

export const WINNING_VERSION_OPTIONS: Array<ControlOption<ComparisonMetricType>> = [
    {
        type: 'large',
        title: 'Open rate',
        subject: 'The winner is the cohort with the highest open rates.',
        content: null,
        value: 'OPEN_RATE',
    },
    {
        type: 'large',
        title: 'Click rate',
        subject: 'The winner is the cohort that clicks the most messages.',
        content: null,
        value: 'CLICK_RATE',
    },
];

export const WINNER_DECLARED_OPTIONS: Array<ControlOption<number>> = [
    {
        type: 'small',
        title: '2 hours',
        value: 2,
    },
    {
        type: 'small',
        title: '4 hours',
        value: 4,
    },
    {
        type: 'small',
        title: '8 hours',
        value: 8,
    },
    {
        type: 'small',
        title: '24 hours',
        value: 24,
    },
];

export function getTestDistributionOptions(edition: Edition): Array<ControlOption<number>> {
    const audienceCount = edition.audience
        ? edition.audience.membershipStats.totalCount.value
        : null;

    return audienceCount
        ? [
              {
                  type: 'large',
                  title: '5%',
                  subject: `${Math.round((audienceCount * 5) / 100)} members`,
                  content: null,
                  value: 5,
              },
              {
                  type: 'large',
                  title: '10%',
                  subject: `${Math.round((audienceCount * 10) / 100)} members`,
                  content: null,
                  value: 10,
              },
              {
                  type: 'large',
                  title: '15%',
                  subject: `${Math.round((audienceCount * 15) / 100)} members`,

                  content: null,
                  value: 15,
              },
              {
                  type: 'large',
                  title: '20%',
                  subject: `${Math.round((audienceCount * 20) / 100)} members`,
                  content: null,
                  value: 20,
              },
          ]
        : [
              {
                  type: 'small',
                  title: '5%',
                  value: 5,
              },
              {
                  type: 'small',
                  title: '10%',
                  value: 10,
              },
              {
                  type: 'small',
                  title: '15%',
                  value: 15,
              },
              {
                  type: 'small',
                  title: '20%',
                  value: 20,
              },
          ];
}

export function getDistributionSections(testDistribution: number) {
    return [
        {
            type: 'defined',
            color: colors.plum,
            percent: testDistribution / 2,
            label: 'A',
            labelColor: colors.white,
        },
        {
            type: 'defined',
            color: colors.sidebarPrimary,
            percent: testDistribution / 2,
            label: 'B',
            labelColor: colors.white,
        },
    ];
}

export function getTieBreakerOptions({
    edition,
    comparisonSubject,
    comparisonPreviewText,
}: {
    edition: Edition;
    comparisonSubject: string | null | undefined;
    comparisonPreviewText: string | null | undefined;
}): Array<ControlOption<ComparisonEditionType>> {
    return [
        {
            type: 'large',
            title: 'Version A',
            subject: edition.emailTemplate ? edition.emailTemplate.subject : '',
            content: edition.emailTemplate ? edition.emailTemplate.previewText : '',
            value: 'MAIN',
        },
        {
            type: 'large',
            title: 'Version B',
            subject: comparisonSubject || '',
            content: comparisonPreviewText || '',
            value: 'ALTERNATE',
        },
    ];
}
